// global
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// consts
import { COLORS } from 'app/config/colors';
// icons
import LoadingIcon from '../../../../../assets/icon/loading-icon/LoadingIcon';
// hook
import useHover from './useHover';
import useButtonState from './useButtonState';
// stylesheet
import styles from './DefaultButton.module.scss';

function DefaultButton(props) {
  const {
    // children,
    isActive,
    tag,
    size,
    icon,
    iconHover,
    iconLoading,
    iconLoadingHover,
    iconDisabled,
    value,
    onClick,
    disabled,
    loading,
    color,
    colorHover,
    borderColor,
    backgroundColor,
    borderColorHover,
    backgroundColorHover,
    fullWidth,
    disableOnClick,
    loadingOnClick,
    ...rest
  } = props;

  const [isHover, buttonRef] = useHover();
  const [clicked, setClicked] = useState(false);

  const { style, showTag, showIcon, reactIcon, isDisabled } = useButtonState({
    icon,
    iconHover,
    iconDisabled,
    iconLoading,
    iconLoadingHover,
    color,
    backgroundColor,
    borderColor,
    colorHover,
    backgroundColorHover,
    borderColorHover,
    isActive,
    isHover,
    loading,
    disableOnClick,
    loadingOnClick,
    disabled,
    clicked
  });

  const handleClassName = () => {
    const isThereTag = tag !== '';
    const styleNoTag = `${styles[size]} ${styles.noTag}`;
    const styleWithTag = `${styles[size]} ${styles.tag}`;

    let className = isThereTag ? styleWithTag : styleNoTag;

    if (fullWidth) className += ` ${styles.fullWidth}`;

    return className;
  };

  // REFACTOR eliminar esse suporte assim que forem criados ícones react
  // suporte a ícones svg
  // const handleIcon = (icon, src) => {
  //   if (isValidElement(icon)) {
  //     return icon;
  //   } else {
  //     return <img style={src} alt='ícone' className={styles.icon} />;
  //   }
  // };

  const handleClick = (...rest) => {
    if (loadingOnClick && clicked) return;
    if (disableOnClick && clicked) return;

    onClick(...rest);

    if (!clicked) setClicked(true);
  };

  return (
    <button
      ref={buttonRef}
      type='button'
      value={value}
      onClick={handleClick}
      disabled={isDisabled}
      className={handleClassName()}
      style={style}
      {...rest}
    >
      {showIcon ? reactIcon : null}
      {showTag && tag}
    </button>
  );
}

DefaultButton.defaultProps = {
  tag: '',
  isActive: false,
  size: 'small',
  disabled: false,
  color: COLORS.WHITE_VARIANT,
  borderColor: COLORS.ACCENTUATED_VARIANT,
  backgroundColor: COLORS.ACCENTUATED_VARIANT,
  colorHover: COLORS.ACCENTUATED_VARIANT,
  borderColorHover: COLORS.ACCENTUATED_VARIANT,
  backgroundColorHover: COLORS.WHITE_VARIANT,
  fullWidth: false,
  disableOnClick: false,
  loadingOnClick: false,
  // iconLoading: <Loading width='20' height='20' fill={COLORS.ACCENTUATED_VARIANT} />,
  // iconLoadingHover: <Loading width='20' height='20' fill={COLORS.WHITE_VARIANT} />,

  iconLoading: <LoadingIcon size='20' fill={COLORS.ACCENTUATED_VARIANT} />,
  iconLoadingHover: <LoadingIcon size='20' fill={COLORS.WHITE_VARIANT} />,

  iconDisabled: <></>,
  onClick: () => {}
};

DefaultButton.propTypes = {
  isActive: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconHover: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconLoading: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconLoadingHover: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconDisabled: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge']),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.oneOf(Object.values(COLORS)),
  borderColor: PropTypes.oneOf(Object.values(COLORS)),
  backgroundColor: PropTypes.oneOf(Object.values(COLORS)),
  colorHover: PropTypes.oneOf(Object.values(COLORS)),
  borderColorHover: PropTypes.oneOf(Object.values(COLORS)),
  backgroundColorHover: PropTypes.oneOf(Object.values(COLORS)),
  fullWidth: PropTypes.bool,
  disableOnClick: PropTypes.bool,
  loadingOnClick: PropTypes.bool
};

export default DefaultButton;
